export const SORTING_OUTPUT_MATERIALS_PREFIX = "@SORTING_OUTPUT_MATERIALS/"
export const FETCH_SORTING_OUTPUT_MATERIALS = `${SORTING_OUTPUT_MATERIALS_PREFIX}FETCH_SORTING_OUTPUT_MATERIALS`
